import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import HeroSection from "./HeroSection";
import AboutUsSection from "./AboutUsSection";
import PolicyFlow from "./PolicyFlow";
import OfferingsPreview from "./OfferingsPreview";
import ImpactFramework from "./ImpactFramework";
import ProcessFlow from "./ProcessFlow";
import PartnersCarousel from "./PartnersCarousel";
import CapacityPreview from "./CapacityPreview";
import CollabMessageSection from "./CollabMessageSection";

export default function Home() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, ease: "easeOut" }}
    >
      <HeroSection />
      <CollabMessageSection />
      <AboutUsSection />
      <CapacityPreview />
      <PolicyFlow />
      <OfferingsPreview />
      {/* <ImpactFramework /> */}
      {/* <ProcessFlow /> */}
      <PartnersCarousel />
    </motion.div>
  );
}
